import React from 'react';
import { Link } from 'react-router';

const SiteFooter: React.FC = () => {
  return (
    <footer className="shrink-0 border-t border-theme-border bg-surface px-4 py-4">
      <div className="container mx-auto flex flex-col items-center justify-center gap-2 text-center text-xs text-on-surface-tertiary sm:flex-row sm:gap-6">
        <span className="text-on-surface-quaternary">
          © {new Date().getFullYear()} Digital Ascension Group
        </span>
        <nav
          className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1"
          aria-label="Legal"
        >
          <Link
            to="/privacy"
            className="text-on-surface-tertiary underline-offset-4 transition-colors hover:text-on-surface hover:underline"
          >
            Privacy Policy
          </Link>
          <Link
            to="/refund-policy"
            className="text-on-surface-tertiary underline-offset-4 transition-colors hover:text-on-surface hover:underline"
          >
            Refund Policy
          </Link>
        </nav>
      </div>
    </footer>
  );
};

export default SiteFooter;
